export class TRRThresholds {
    automation: number = 0;
    security: number = 0;
    fire: number = 0;
    electrical: number = 0;
    firePartsAndSmarts: number = 0;
    mechanical: number = 0;
}